import React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

// Import components
import { Heading } from 'components/elements';
import Packet from './Packet';

const PacketsMobile = ({ subtype }) => {
	const { t } = useTranslation();
	const { data: packets } = useSelector(
		({ product_packets }) => product_packets
	);

	if (!packets.length) return null;

	return (
		<Wrapper>
			<HeadingSecondStyled>
				{t(`packets_slider_${subtype}_packets_available`)}
			</HeadingSecondStyled>
			<Box>
				{packets.map((packet) => (
					<Packet {...packet} />
				))}
			</Box>
		</Wrapper>
	);
};

const Wrapper = styled.div`
	padding: 3rem 0;
`;

const HeadingSecondStyled = styled(Heading.Second)`
	text-align: center;
	font-weight: ${({ theme }) => theme.font.normal};
	margin-bottom: 0rem;
`;

const Box = styled.div`
	margin: 5rem 0;
	padding: 0 2rem;
	display: flex;
	flex-direction: column;
	justify-content: center;
`;

PacketsMobile.propTypes = {
	subtype: PropTypes.string
};

export default PacketsMobile;
